// Yandex Metrika ID
const YANDEX_METRIKA_ID = 100168388

// Production domain (metrika will only load on this domain)
const PRODUCTION_DOMAIN = 'softrest.ru'

// Flag to track if Metrika is already loaded
let isMetrikaLoaded = false

// Declare ym function type for TypeScript
declare global {
  interface Window {
    ym?: (id: number, method: string, ...args: any[]) => void
  }
}

/**
 * Check if current domain is production
 */
function isProductionDomain(): boolean {
  const hostname = window.location.hostname
  return hostname === PRODUCTION_DOMAIN || hostname === `www.${PRODUCTION_DOMAIN}`
}

/**
 * Check if user has accepted analytics
 */
export function hasAnalyticsAccepted(): boolean {
  return localStorage.getItem('cookieConsent') === 'accepted'
}

/**
 * Check if user has explicitly declined analytics
 */
export function hasAnalyticsDeclined(): boolean {
  return localStorage.getItem('cookieConsent') === 'declined'
}

/**
 * Initialize Yandex Metrika analytics
 * This function should only be called after user explicitly accepts cookies (opt-in model)
 */
export function initYandexMetrika() {
  // Check if user has accepted (opt-in model)
  if (!hasAnalyticsAccepted()) {
    return
  }

  // Prevent multiple initialization
  if (isMetrikaLoaded) {
    return
  }

  // Check if we are on production domain
  if (!isProductionDomain()) {
    return
  }

  try {
    // Create script element with the exact code from Laravel
    const script = document.createElement('script')
    script.type = 'text/javascript'
    
    // Use textContent instead of innerHTML to avoid parsing issues
    script.textContent = `
      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      ym(${YANDEX_METRIKA_ID}, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
      });
    `

    // Append script to document
    document.head.appendChild(script)

    // Create noscript fallback
    const noscript = document.createElement('noscript')
    const div = document.createElement('div')
    const img = document.createElement('img')
    img.src = `https://mc.yandex.ru/watch/${YANDEX_METRIKA_ID}`
    img.style.position = 'absolute'
    img.style.left = '-9999px'
    img.alt = ''
    div.appendChild(img)
    noscript.appendChild(div)
    document.body.appendChild(noscript)

    isMetrikaLoaded = true
  } catch (error) {
    console.error('Failed to initialize Yandex Metrika:', error)
  }
}

/**
 * Initialize Metrika on app startup (opt-in model)
 * Metrika only loads if user has previously accepted cookies
 */
export function initMetrikaOnStartup() {
  // Only load if user has accepted (opt-in model)
  if (hasAnalyticsAccepted()) {
    initYandexMetrika()
  }
}

/**
 * Start tracking after user accepts (opt-in model)
 * This is called when user clicks "Accept" on cookie consent banner
 */
export function startMetrikaTracking() {
  if (!isMetrikaLoaded) {
    initYandexMetrika()
  }
}
